// extracted by mini-css-extract-plugin
export default {"showOnMobile":"screen-conditions_showOnMobile__tnVZu","showOnWeb":"screen-conditions_showOnWeb__MTjFu"};